// src/App.tsx - UPDATED CONTENT

import React, { useEffect } from 'react';
// REMOVED: BrowserRouter as Router, ThemeProvider, ShopProvider, AuthProvider imports
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom'; // Keep Routes, Route, Navigate, Outlet



// Contexts - Only import useAuth and ProductProvider now
import { useAuth } from './context/AuthContext';
import { ProductProvider } from './context/ProductContext'; // Make sure this path is correct

// Main Website Layout Components
// import Navbar from './components/Navbar/navbar';
import Footer from './components/Footer';
import Home from './components/Slider/ImageSlider';
import CollectionPage from './components/Collection/CollectionPage';
import DealPage from './components/Deal/DealPage';
import ProductPage from './components/Products/ProductPage';
import VisitStorePage from './components/Visit/VisitStorePage';
import About from './components/About';
import SubscribePage from './components/SubscribePage';
import TestimonialPage from './components/TestimonialPage';

// Main Website Pages
import Earrings from './pages/Earrings';
import Necklaces from './pages/Necklaces';
import Bangles from './pages/Bangles';
import Chains from './pages/Chains';
import Rings from './pages/Rings';
import Pendants from './pages/Pendants';
import Bracelets from './pages/Bracelets';
import CoinsAndBars from './pages/CoinsAndBars';
import AllJewellery from './pages/AllJewellery';
import Collections from './pages/Collections';

// Admin Components
import AdminDashboard from './admin/components/AdminDashboard';
import AdminLayout from './admin/bars/AdminLayout'; // IMPORTANT: Create this file if it doesn't exist
import CreateProduct from './admin/components/CreateProduct';
import ProductList from './admin/components/ProductList';
import LivePrices from './admin/components/LivePrices';
import BillingPage from './admin/components/BillingPage';
import { Login } from '@mui/icons-material';

import Navbar from './components/Navbar/navbar';

import MangalsutraPage from './pages/MangalsutraPage';
import MaangTikkaPage from './pages/MaangTikkaPage';
import HathPanPage from './pages/HathPanPage';
import SadiPinPage from './pages/SadiPinPage';
import JudaPage from './pages/JudaPage';

import VisitShopPage from './components/Visit/ShopDetailsPage';
import PrivacyPolicyPage from './pages/Footerpage/PrivacyPolicyPage';
import RefundPolicyPage from './pages/Footerpage/RefundPolicyPage';
import TermsOfUsagePage from './pages/Footerpage/TermsOfUsagePage';
import AboutUsPage from './pages/Footerpage/AboutUsPage';
import UserProfilePage from './components/Navbar/UserProfilePage';
import UserOrdersPage from './components/Navbar/OrdersPage';

import WishlistPage from './components/Navbar/WishlistPage';
import WalletPage from './components/Navbar/WalletPage';

import EditProduct from './admin/components/EditProduct';
import FeaturedCollections from './components/Featured Collections';
import Customers from './admin/components/CustomerList';
import CheckoutPage from './components/CheckoutPage';
import CartPage from './components/CartPage';
import AdminOrderList from './admin/components/AdminOrderList';
import AdminCartList from './admin/components/AdminCartList';

// Auth Components
// import Login from './admin/components/Login'; // Make sure this path is correct

// 💡 नया कॉम्पोनेंट: ScrollToTop
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    // हर बार 'pathname' (रूट) बदलने पर, विंडो को (0, 0) पर स्क्रॉल करें।
    window.scrollTo(0, 0); 
  }, [pathname]); 

  return null;
};

// Protected Route Component (Keep this as is, or define if not already)
interface ProtectedRouteProps {
  allowedRoles: number[];
  children?: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ allowedRoles, children }) => {
  const { user, isLoading } = useAuth(); // Now safe to call here
  

  if (isLoading) {
    return <div>Loading authentication...</div>;
  }

  if (!user) {
    return <Navigate to="/" replace />;
  }

  if (!allowedRoles.includes(user.userRole)) {
    return <Navigate to="/" replace />; // Redirect unauthorized roles to home
  }

  return children ? <>{children}</> : <Outlet />;
};

// Main Website Layout Component - This component encapsulates the shared layout for your main site
// It now defines its own internal Routes for the main website's pages
const MainWebsiteLayout: React.FC = () => {
  const [showDealPage, setShowDealPage] = React.useState(false);
 
  return (

    <>
    <ScrollToTop />
      <Navbar /> {/* This Navbar will appear on all main website pages */}
      <Routes>
        {/* Home route with all sections - this will render when path matches "/" within MainWebsiteLayout */}
        <Route
          path="/"
          element={
            <>
              <Home />
              <CollectionPage />
              <FeaturedCollections />
              {showDealPage && <DealPage />} 
             
              
              <ProductPage />
              <VisitStorePage />
              <About />
              <SubscribePage />
              <TestimonialPage />
            </>
          }
        />


        {/* Main Profile Page (This is the parent route) */}
        <Route path="/profile" element={<UserProfilePage />} />
          <Route path="/addresses" element={<UserProfilePage />} />
          <Route path="/orders" element={<UserProfilePage />} />
          <Route path="/wishlist" element={<UserProfilePage />} />
          <Route path="/wallet" element={<UserProfilePage />} />
        {/* <Route path="/wishlist" element={<WishlistPage />} /> */}
        {/* <Route path="/profile/address-book" element={<UserProfilePage />} /> */}
        {/* <Route path="/wallet" element={<WalletPage />} /> */}
 {/* Separate routed pages */}
            
            <Route path="/contact" element={<VisitShopPage />} />


            <Route path="/earrings" element={<Earrings />} />
             <Route path="/necklaces" element={<Necklaces />} />
             <Route path="/bangles" element={<Bangles />} />
             <Route path="/chains" element={<Chains />} />
             <Route path="/rings" element={<Rings />} />
             <Route path="/pendants" element={<Pendants />} />
             <Route path="/bracelets" element={<Bracelets />} />
             <Route path="/coins-bars" element={<CoinsAndBars />} />
             <Route path="/Mangalsutra" element={<MangalsutraPage />} />
             <Route path="/maangtikka" element={<MaangTikkaPage />} />
             <Route path="/hathpan" element={<HathPanPage />} />
             <Route path="/sadipin" element={<SadiPinPage />} />
              <Route path="/juda" element={<JudaPage />} />
             <Route path="/all-jewellery" element={<AllJewellery />} />
             <Route path="/collections" element={<Collections />} />

             <Route path="/cart" element={<CartPage />} />
             <Route path="/checkout" element={<CheckoutPage />} />
              <Route path="/wishlist" element={<WishlistPage />} />
             
            {/* Add more routed pages like /rings, /pendants etc if needed */}

             <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/refund" element={<RefundPolicyPage />} />
               <Route path="/term" element={<TermsOfUsagePage />} />
              
                <Route path="/about" element={<AboutUsPage />} />
               
               
        {/* Add more specific main website routes here if they don't appear on the home page */}
      </Routes>
      <Footer /> {/* This Footer will appear on all main website pages */}
    </>
  );
};


const App: React.FC = () => {
  // useAuth() can now be safely called directly inside App because AuthProvider is above it in index.tsx
  const { user, isLoading } = useAuth();

  // Show a loading screen while authentication status is being determined
  if (isLoading) {
    return <div>Loading application...</div>;
  }

  return (
    // <Router>, <ThemeProvider>, <ShopProvider>, <AuthProvider> are now in index.tsx
    <Routes>
      {/* Public route for Login */}
      <Route path="/login" element={<Login />} />

      {/*
        Main Website Routes (accessible by everyone or handled by specific components).
        The "/*" ensures that any path not matching /login or /admin will render MainWebsiteLayout.
        The actual sub-routes (e.g., /earrings) are handled by the <Routes> inside MainWebsiteLayout.
      */}
      <Route path="/*" element={<MainWebsiteLayout />} />

      {/* Protected Routes for Admin (role 1) */}
      <Route path="/admin" element={<ProtectedRoute allowedRoles={[1]} />}>
        {/*
          AdminLayout provides the common layout for admin pages (sidebar, header).
          ProductProvider wraps admin product-related routes to provide product context.
        */}
        <Route element={<ProductProvider><AdminLayout /></ProductProvider>}>
          <Route path="dashboard" element={<AdminDashboard />} />
          <Route path="products/create" element={<CreateProduct />} />
          <Route path="products/list" element={<ProductList />} />
          {/* <Route path="products/edit/:type/:id" element={<EditProduct />} />  */}
          <Route path="edit-product/:type/:id" element={<EditProduct />} />
          <Route path="orders/cart" element={<AdminCartList />} />
          <Route path="orders/list" element={<AdminOrderList />} />
          {/* <Route path="orders" element={<div>Order Management Content</div>} />
          <Route path="customers" element={<div>Customer Management Content</div>} />
          <Route path="reports" element={<div>Sales Reports Content</div>} />
          <Route path="settings" element={<div>Settings Content</div>} /> */}
          <Route path="live-price" element={<LivePrices />} />
          <Route path='billing' element={<BillingPage />} /> {/* Path is relative to /admin */}
          <Route path='customers' element={<Customers />} /> {/* Path is relative to /admin */}

          {/* Default admin path inside /admin if no specific child route matches */}
          <Route path="*" element={<Navigate to="dashboard" replace />} />
        </Route>
      </Route>

      {/* Fallback for any unhandled routes (e.g., a direct URL to a non-existent page) */}
      <Route path="*" element={<div>404 Not Found</div>} />
    </Routes>
  );
};

export default App;